import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class EmployerHiringUpdateAttributes {
  id: string = null;
  foundJob: boolean = null;
  platform: string[] = null;
  hiredUserListings: {
    userProfileId?: string;
    userProfileName?: string;
    jobListingId?: string;
    roleTitle?: string;
    locationId?: string;
  }[] = null;
  noEarlydayReason: string[] = null;
}

export class EmployerHiringUpdateBelongsTo {}

export class EmployerHiringUpdateHasOne {}

export class EmployerHiringUpdateHasMany {}

/**
 * Utility interfaces
 */
export interface EmployerHiringUpdateMethods {}

export interface EmployerHiringUpdateInterface
  extends EmployerHiringUpdateAttributes,
    EmployerHiringUpdateBelongsTo,
    EmployerHiringUpdateHasOne,
    EmployerHiringUpdateHasMany,
    EmployerHiringUpdateType {}

type EmployerHiringUpdateType = GConstructor<EmployerHiringUpdateInterface>;

export interface EmployerHiringUpdateResource
  extends Base<EmployerHiringUpdateAttributes>,
    EmployerHiringUpdateInterface,
    EmployerHiringUpdateMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<EmployerHiringUpdateAttributes>({
    queryName: 'employer/hiring_updates',
    className: 'EmployerHiringUpdate',
    AttributesClass: EmployerHiringUpdateAttributes,
    BelongsToClasses: [
      {
        Klass: EmployerHiringUpdateBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: EmployerHiringUpdateHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: EmployerHiringUpdateHasMany,
      },
    ],
  });

export const EmployerHiringUpdateResourceClass = <TBase extends EmployerHiringUpdateType>(
  BaseConstructor: TBase,
) => class extends BaseConstructor implements EmployerHiringUpdateMethods {};

export class EmployerHiringUpdateResource extends ClassExtender<EmployerHiringUpdateInterface>(
  BaseClass,
  EmployerHiringUpdateResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerHiringUpdate = APILibrary.createResource<EmployerHiringUpdateResource>(
  EmployerHiringUpdateResource,
);
